// Map scale facts the trail map card needs before MapLibre (and the style in
// topoStyle.ts) have loaded: contour spacing for the key, and where trails start.

/** Contour spacing per zoom as [minor, index]: feet for °F households, meters otherwise. */
export const CONTOURS: Record<"ft" | "m", Record<number, [number, number]>> = {
  ft: { 8: [1000, 5000], 9: [500, 2500], 10: [200, 1000], 11: [200, 1000], 12: [100, 500], 13: [40, 200], 14: [40, 200] },
  m: { 8: [300, 1500], 9: [200, 1000], 10: [100, 500], 11: [50, 250], 12: [50, 250], 13: [20, 100], 14: [10, 50] },
};

/** The [minor, index] spacing in effect at a (fractional) zoom. */
export function contourStep(unit: "ft" | "m", zoom: number): [number, number] | null {
  const table = CONTOURS[unit];
  const z = Object.keys(table)
    .map(Number)
    .filter((k) => k <= Math.floor(zoom))
    .sort((a, b) => b - a)[0];
  return z === undefined ? null : table[z]!;
}

/** Trails and 4×4 tracks first appear in OpenFreeMap's zoom-12 tiles. */
export const TRAIL_MINZOOM = 12;
